import React from "react";
import { Button } from "./ui/button";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
  DialogClose,
} from "./ui/dialog";
import { OctagonAlert, Trash2 } from "lucide-react";

const DeleteModal = ({ content, handleDelete }) => {
  return (
    <Dialog>
      <DialogTrigger asChild>
        <div className="group border rounded-md p-1 border-destructive hover:bg-destructive duration-200 cursor-pointer">
          <Trash2 className="w-4 h-4 text-destructive group-hover:text-white" />
        </div>
      </DialogTrigger>
      <DialogContent className="sm:max-w-[425px] bg-lightGray">
        <DialogHeader>
          <DialogDescription className="flex items-center justify-center">
            <OctagonAlert className="text-destructive h-14 w-14" />
          </DialogDescription>
          <DialogTitle className="text-center pt-4 text-white">
            Are You Sure?
          </DialogTitle>
        </DialogHeader>
        <div className="grid gap-4 py-4">
          <DialogDescription className="text-center text-white">
            Are you sure you want to delete <strong> {content}</strong> ?
          </DialogDescription>
        </div>
        <DialogFooter>
          <DialogClose asChild>
            <Button
              type="button"
              variant="outline"
              className="w-full bg-primary hover:bg-[#8C7DFF] text-white hover:text-white text-base border-0"
            >
              Cancel
            </Button>
          </DialogClose>
          <DialogClose asChild>
            <Button
              type="submit"
              variant="destructive"
              className="w-full"
              onClick={handleDelete}
            >
              Delete
            </Button>
          </DialogClose>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default DeleteModal;
